/**
 *
 *  isSameDay
 *  TruBe Date Time helper
 *
 *  Created by Vladimir Shishlyannikov on 24/02/2023.
 *  Copyright (c) 2016-present iWoo Ltd. All rights reserved.
 *
 */

export default function isSameDay(date_t, date_n) {
  return (
    !(!date_t || !date_n) &&
    date_t.date() === date_n.date() &&
    date_t.month() === date_n.month() &&
    date_t.year() === date_n.year()
  );
}
